import { render, staticRenderFns } from "./viewRoleDialog.vue?vue&type=template&id=622ff857&scoped=true"
import script from "./viewRoleDialog.vue?vue&type=script&lang=js"
export * from "./viewRoleDialog.vue?vue&type=script&lang=js"
import style0 from "./viewRoleDialog.vue?vue&type=style&index=0&id=622ff857&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "622ff857",
  null
  
)

export default component.exports